// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"LoadingOverlay_loadingOverlay__VwOz0","iconLoading":"LoadingOverlay_iconLoading__ru3EY","spin":"LoadingOverlay_spin__b9m-x"};